import TimelineToCompletionTypeChart from './TimelineToCompletionTypeChart';

export default TimelineToCompletionTypeChart;
